import React from "react";
import { Task } from "../../../types";
import { Button } from "@bandit-network/react-ui-kit";
import { CheckCircledIcon, ExternalLinkIcon } from "@radix-ui/react-icons";
import { useQuestContext } from "../../../context/QuestContext";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface ThresholdScoreProps {
  data: Task;
}

const ThresholdScore: React.FC<ThresholdScoreProps> = ({ data }) => {
  const { tasksCompleted } = useQuestContext();

  const visit = () => {
    window.open("https://passport.gitcoin.co/");
  };

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <Button
        variant="link"
        size="sm"
        className="bad-quest__task--action_button"
        onClick={visit}
        disabled={isTaskComplete}
      >
        {isTaskComplete ? `Completed` : `Visit`}
        {isTaskComplete ? (
          <CheckCircledIcon className="bad-quest__task--check_icon" />
        ) : (
          <ExternalLinkIcon className="bad-quest__task--link_icon" />
        )}
      </Button>
    </div>
  );
};

export { ThresholdScore };
